<template>
    <button
        v-tippy="t('editorToggleSuperscript')"
        :class="[
            buttonState(
                editor.can().toggleSuperscript() && editorSelection.text.length > 0,
                editor.isActive('superscript'),
            ),
            'flex-none rounded p-1 text-sm',
        ]"
        :disabled="!editor.can().toggleSuperscript() || editorSelection.text.length === 0"
        @click="editor.chain().focus().toggleSuperscript().run()"
    >
        <MdiFormatSuperscript class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import { MdiFormatSuperscript } from 'materialdesignicons-vue3/icons/';

    defineExpose({
        name: 'SuperscriptTextButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
        editorSelection: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
    const editorSelection = props.editorSelection;
</script>
